import React from 'react';
import { Box, Container, Typography, Divider, Link, List, ListItem } from '@mui/material';

const PrivacyPolicyPage = () => {
  return (
    <Box sx={{ py: { xs: 3, sm: 4 }, backgroundColor: (t) => t.palette.background.default }}>
      <Container maxWidth="md">
        <Typography variant="h3" component="h1" sx={{ fontWeight: 700, mb: 2 }}>
          Политика конфиденциальности BillingService
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Редакция от: 31 августа 2025 г. • Оператор ПДн: [наименование, ИНН/ОГРН, адрес]
        </Typography>
        <Divider sx={{ mb: 3 }} />

        <Typography variant="h5" sx={{ mt: 2, mb: 1.25 }}>1. Общие положения</Typography>
        <Typography>
          Политика регулирует обработку персональных данных в соответствии с Федеральным законом № 152-ФЗ.
          Оператор — [наименование]. Контакты: <Link href="mailto:privacy@billingservice.ru">privacy@billingservice.ru</Link>.
        </Typography>

        <Typography variant="h5" sx={{ mt: 2, mb: 1.25 }}>2. Категории данных</Typography>
        <List>
          <ListItem>Пользователи: e-mail, телефон, пароль (в виде хеша), логи доступа.</ListItem>
          <ListItem>Счётчики/объекты: серийный номер, адрес установки, привязка к дому/квартире, показания, дата/время.</ListItem>
        </List>

        <Typography variant="h5" sx={{ mt: 2, mb: 1.25 }}>3. Цели и основания</Typography>
        <List>
          <ListItem>Регистрация, аутентификация, предоставление функционала Сервиса (договор/оферта).</ListItem>
          <ListItem>Безопасность, поддержка, уведомления (законный интерес/требования закона).</ListItem>
          <ListItem>Маркетинговые рассылки — только с согласия; можно отозвать.</ListItem>
        </List>

        <Typography variant="h5" sx={{ mt: 2, mb: 1.25 }}>4. Хранение и безопасность</Typography>
        <Typography>
          Данные хранятся на серверах на территории РФ, пароли — с использованием современного алгоритма хеширования,
          шифрование трафика, разграничение доступа, аудит действий.
        </Typography>

        <Typography variant="h5" sx={{ mt: 2, mb: 1.25 }}>5. Передача третьим лицам</Typography>
        <Typography>
          Подрядчики (хостинг, SMS/e-mail, интеграции) — по договорам поручения обработки с обязательствами конфиденциальности.
        </Typography>

        <Typography variant="h5" sx={{ mt: 2, mb: 1.25 }}>6. Права субъекта ПДн</Typography>
        <List>
          <ListItem>Доступ, исправление, удаление, ограничение, отзыв согласия.</ListItem>
          <ListItem>Порядок запросов: на <Link href="mailto:privacy@billingservice.ru">privacy@billingservice.ru</Link>, срок ответа — 30 дней.</ListItem>
        </List>

        <Typography variant="h5" sx={{ mt: 2, mb: 1.25 }}>7. Сроки хранения</Typography>
        <Typography>До достижения целей обработки, а также иные сроки, установленные законодательством РФ и/или договором.</Typography>

        <Typography variant="h5" sx={{ mt: 2, mb: 1.25 }}>8. Изменения Политики</Typography>
        <Typography>Новая редакция публикуется на сайте с указанием даты. Продолжение использования = согласие с новой редакцией.</Typography>
      </Container>
    </Box>
  );
};

export default PrivacyPolicyPage;
